/** Platform flag for the Food Profile refresh. Read it only in `Food.tsx` (the version switch). */
export const FOOD_PROFILE_REFRESH_FLAG = 'Food Profile Refresh';

/** Section anchors shared by both page versions, the sections nav and the sections themselves. */
export enum FoodSectionEnum {
    Summary = 'FoodSection--Summary',
    MenuAndConsumer = 'FoodSection--MenuAndConsumer',
    Menu = 'FoodSection--Menu',
    Consumer = 'FoodSection--Consumer',
    Social = 'FoodSection--Social',
    Charts = 'FoodSection--Charts',
    Reports = 'FoodSection--Reports',
    Launches = 'FoodSection--Launches',
}

/** Id of the page scroll container; react-scroll and the scroll-to-top button target it. */
export const FOOD_PAGE_SCROLLBAR_ID = 'FoodPageScrollbar';
